import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MarchMadness from "../pages/march-madness/page";
import SuperBowlProps from "../pages/super-bowl-props/page";
import Markets from "../pages/markets/page";
import WhyRTJ from "../pages/why-rtj/page";
import MyAccount from "../pages/my-account/page";
import MarketsSpreadsPage from "../pages/markets/spreads/page";
import MarketsMoneyLinesPage from "../pages/markets/money-lines/page";
import MarketsFuturesPage from "../pages/markets/futures/page";
import MarketsParlaysPage from "../pages/markets/parlays/page";
import MarketsPlayerPropsPage from "../pages/markets/player-props/page";
import LiquidityEdge from "../pages/liquidity-edge/page";
import L2LStrategy from "../pages/fanduel-predicts/page";
import SalesFunnel from "../pages/sales-funnel/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/march-madness", element: <MarchMadness /> },
  { path: "/olympics-props", element: <MarchMadness /> },
  { path: "/super-bowl-props", element: <SuperBowlProps /> },
  { path: "/markets", element: <Markets /> },
  { path: "/markets/spreads", element: <MarketsSpreadsPage /> },
  { path: "/markets/money-lines", element: <MarketsMoneyLinesPage /> },
  { path: "/markets/futures", element: <MarketsFuturesPage /> },
  { path: "/markets/parlays", element: <MarketsParlaysPage /> },
  { path: "/markets/player-props", element: <MarketsPlayerPropsPage /> },
  { path: "/why-rtj", element: <WhyRTJ /> },
  { path: "/why-l2l", element: <WhyRTJ /> },
  { path: "/liquidity-edge", element: <LiquidityEdge /> },
  { path: "/my-account", element: <MyAccount /> },
  { path: "/l2l-strategy", element: <L2LStrategy /> },
  { path: "/segmentation-strategy", element: <SalesFunnel /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
